import { UpdateFuelSurchargeFields } from "../dtos/UpdateRateCardRequest";
import { UpdateRouteRateUIRequest } from "../routeRate/UpdateRouteRateModal";

export const mapValuesUiRequestToUpdateFuelSurchargeFields = (
  uiRequest: UpdateRouteRateUIRequest,
  username: string | undefined
): UpdateFuelSurchargeFields[] => {
  let fuelSurchargeFieldsList: UpdateFuelSurchargeFields[] = [];

  if (uiRequest.show_fuel_surcharge) {
    if (uiRequest.fuelSurchargeFields.length > 0) {
      uiRequest.fuelSurchargeFields.forEach((surcharge) => {
        if (surcharge.fieldName && surcharge.fieldOperator) {
          let field: UpdateFuelSurchargeFields = {
            id: surcharge.id ?? undefined,
            isActive: true,
            fieldName: surcharge.fieldName,
            fieldOperator: surcharge.fieldOperator,
            createdBy: surcharge.createdBy ?? `${username}`,
            updatedBy: `${username}`,
          };
          fuelSurchargeFieldsList.push(field);
        }
      });
    }
  }
  return fuelSurchargeFieldsList;
};

